module.exports = __webpack_public_path__ + "img/album09_01.7bdd503d.jpg";